
<!-- 
  PR HOME PAGE 
-->

<template lang="html">
  <div>
    <section class="hero is-medium project-header">
      <img class="project-header-img-desktop" :src="'../../static/img/common/home_poster.jpg'" />
    </section>
    
    <section class="content">  
      <div class="content-inner">
        <task-list 
          v-for="(project,index) in projects"
          :project="project"
          :index="index"
        >
        </task-list>
      </div>
    </section>

  </div>
</template>

<style type="text/css">

  body {
    padding:0;
    margin:0;
  }
  section {
    background: transparent;
    padding:0!important;

  }
  .container {
    margin: 0!important;
  }
  .content-inner {
    width: 727px;
    margin: 0 auto;
  }
  .is-primary {
    background-color: #333!important;
  }

  .article-holder {
    position:relative; 
    margin:10px 0 0;
    padding:0;
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;
    background-color: #ebebeb;
    height: 188px;
  }

  .article-square-info {
    width: 148px;
    height:188px;
    position: absolute;
    top:0;
    background-color: rgba(0,0,0,0.8);
    text-align: left;
    padding:0 20px;
  }
  .article-square-info h3 {
    color:#fff;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .article-square-info p {
    color:#fff;
    font-size: 11px;
    line-height: 15px;
  }
  .article-holder-date {
    position: absolute;
  }
  .article-type-content .article-holder-date {
    color:#fff;
    font-size: 11px;
    bottom: 5px;
  }
  .article-type-link .article-holder-date {
    color:#000;
    font-size: 18px;
    bottom: 10px;
    right:50px;
  }

  .article-square-active {
    width:100%!important;
  }
  .article-square-inner {
    height:auto;
    color:black;
    background-size:100%;
  }
  .article-square-inner h1 {
    text-align: center;
    font-weight: 100;
    color: #000;
    font-size: 16px;
    position: relative;
    margin:0 auto;
    z-index: 9999;
    padding:5px 0;
    bottom: 0px;
    width: 100%;
    background: white;
  }
  .article-holder img {
    display: block;
  }
  .article-square-inner-text-img {
    position: absolute;
    opacity: 0;
    top:0;
  }
/*  .article-square:hover > .article-square-inner-text-img, .article-square:active > .article-square-inner-text-img {
    opacity: 1!important;
  }*/
  .is-tab {
    padding:0!important;
    margin:0!important;
  }

  h1, p {
    color: #ADADAD;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-weight:200;
  }

  .item {
    width: 100%;
    height:188px;
    overflow: hidden;
    margin: 10px 0;
  }

  @media only screen and (max-width: 900px) {

  }

  @media only screen and (max-width: 700px) {

  }
  
  @media only screen and (max-width: 500px) {

  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  @media only screen and (max-width: 620px) {
      
  }

</style>

<script>
import Vue from 'vue'
import postData from '../../content.json'

Vue.component('task-list', {
  // declare the props
  props: ['project', 'index'],
  data: function () {
    return {
      dir: this.project.dir
    }
  },
  // just like data, the prop can be used inside templates
  // and is also made available in the vm as this.message
  template: `<router-link class="is-tab" :to="{ name: 'single-project', params: { id: project.dir, project: project, title: project.title }}">
     
     <div v-if="project.type == 'content'" class="article-holder article-type-content item">
      <img :src="'../static/img/site/'+project.thumb+'.jpg'" />
      <div class="article-square-info">
        <h3 v-html="project.title"></h3>
        <p v-html="project.abstract"></p>
        <div class="article-holder-date" v-html="project.date"></div>
      </div>  
    </div>

    <div v-if="project.type == 'link'" class="article-holder article-type-link item">
      <div class="article-link-info">
        <h3 v-html="project.abstract"></h3>
        <p v-html="project.source"></p>
        <div class="article-holder-date" v-html="project.date"></div>
      </div>  
    </div>

  </router-link>`,
  computed: {
    classIndex: function () {
      return Math.floor(Math.random() * 3)
    },
    checkUrl: function () {
      var val = false
      if (this.url === this.dir || this.url === undefined) val = true
      return val
    },
    showProject: function () {
      var val = false
      if (this.url === this.dir) val = true
      return val
    }
  }
})

export default {
  name: 'main',
  data: function () {
    return {
      projects: [],
      url: ''
    }
  },
  methods: {
    loadProjects: function () {
      this.projects = postData
      // this.$http.get('http://localhost:8080/content.json').then((response) => {
      //   // depending on your api, you may or may not have to make the .json() call
      //   // if your repsonse.body is null, try this
      //   console.log(response)
      //   response.json()
      //   this.projects = response.body
      // }, (err) => {
      //   console.log(err)
      // })
    }
  },
  mounted: function () {
    this.loadProjects()
  }
}
</script>


// WEBPACK FOOTER //
// main.vue?2f72a1b8